/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import SignUp from './sign-up';
import SignUpView from './sign-up.view';

export * from './components';
export * from './sign-up';
export * from './sign-up.props.autogenerated';
export * from './sign-up.view';

export { SignUp, SignUpView };
